module.exports = __webpack_public_path__ + "static/media/notification.27854881.png";